import type { SVGProps } from 'react';
const SvgArrowUpBold = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={12} fill="none" viewBox="0 0 10 12" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.25 5.25 5 1.5m0 0 3.75 3.75M5 1.5v9"
    />
  </svg>
);
export default SvgArrowUpBold;
